import * as moment from 'moment';
import 'moment/min/locales';

// Due to circular dependency problems, import 
import('./localizationManager')
    .then(({ getCurrentLocale }) => {
        moment.locale(getCurrentLocale());
    });

export default moment;